export const COMMIT_HASH = "cf1152489808ec3ae17b8939f12f6b6dfcb2e3af";
export const SHORTBREAD_VERSION = "1.0.14.2";
